import { WallboxModel } from '../models/wallbox-model'

/**
 * Retrieves the solar price for a given wallbox based on its active display tariff.
 *
 * If the wallbox has no tariff to display, the function returns `undefined`.
 * - For **dynamic tariffs**, the solar price is obtained from the first available
 *   dynamic price component within `dynamicPrices`.
 * - For **static tariffs**, the solar price is read directly from `staticPrices.solarPrice`.
 */
export const getWallboxSolarPrice = (wallbox: WallboxModel): number | undefined => {
  if (!wallbox.tariffToDisplay) {
    return undefined
  }

  if (wallbox.tariffToDisplay.tariffCategory === 'DYNAMIC') {
    /** dynamic prices store the solar price within the individual price components that make up a single dynamic price */
    return wallbox.tariffToDisplay.dynamicPrices.find(priceComponent => !!priceComponent)?.solarPrice
  } else {
    /** static prices have a single field in the response that returns the solar price without any lookup needed */
    return wallbox.tariffToDisplay.staticPrices.solarPrice
  }
}
